export default {
  whoWeAre: "Kik vagyunk",
  whoWeAreDescription: "Egy vezető gyógyszeripari platform 40+ év API kiválósággal, globális partnerségekkel fejlett köztitermékekben, és CRDMO szakértelemmel speciális formulációkban és antibiotikumokban.",
  globalImpactExcellence: "Globális hatás és kiválóság",
  globalImpactDescription: "A világ minden tájáról származó partnerek bíznak bennünk, hogy értékes innovációkat nyújtsunk a tudományon keresztül.",
  whatWeOffer: "Mit kínálunk",
  whatWeOfferDescription: "Átfogó gyógyszeripari megoldások, amelyeket évtizedes szakértelem és globális elérés támaszt alá, innovációt nyújtva a laborból az életbe különböző terápiás területeken.",
  regulatoryApprovals: "Szabályozási jóváhagyások",
  regulatoryApprovalsDescription: "A Refex Life Sciences egy világszerte elterjedt, legmodernebb gyártó létesítményekből álló hálózatot működtet, amely zökkenőmentesen integrálódik a csoportba. Ezek a létesítmények a legmagasabb nemzetközi minőségi szabványoknak megfelelnek, akkreditációkkal:",
  regulatoryApproval1: "US FDA",
  regulatoryApproval2: "EU GMP",
  regulatoryApproval3: "EDQM",
  regulatoryApproval4: "Health Canada",
  regulatoryApproval5: "ANVISA",
  regulatoryApproval6: "PMDA",
  regulatoryApproval7: "WHO-GMP",
  noOfferingsAvailable: "Nincs elérhető ajánlat. Kérjük, adjon hozzá néhányat az admin panelben.",
};

